document.addEventListener('DOMContentLoaded', function() {
  // 暂停所有视频播放
  function pauseVideo() {
    let child_length = $('.image_list .image_item').length;
    for (let i = 1; i <= child_length; i++) {
        let videoEl = document.getElementById(`video-${i}`);
        try {
            videoEl.pause();
        } catch (error) { }
    }
  }
  var mySwiper = new Swiper('.swiper_product', {
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    autoHeight: true,
    fadeEffect:{
        crossFade: true
    },
    navigation: {
        nextEl: '.button_next',
        prevEl: '.button_prev',
    },

    // 防止一开始弹窗为none时swiper切换无效
    observer: true,
    observeParents: true,
    on: {
        slideChangeTransitionEnd: function () {
            pauseVideo();
            try {
                document.getElementById(`video-${this.activeIndex}`).play();
            } catch (error) { }
        },
    },
  });

  // 产品点击事件
  let scrollTop = '';
  $('.image_list .image_item .user-showcase-item').click(function () {
    let index = $(this).attr('index')
    var num = index - 1
    mySwiper.slideTo(num, 0);
    $('.product_dialog').css('display', 'block');
    scrollTop = $(window).scrollTop();
    $('body').css('top', 0 - scrollTop);
    $('body').addClass('noscroll');
    document.getElementById(`video-${index}`).play();
  });

  // 关闭弹窗
  $('.product_dialog .close_dialog').click(function () {
    pauseVideo();
    $('.product_dialog').css('display', 'none');
    $('body').removeClass('noscroll');
    $(window).scrollTop(scrollTop);
  });

  // show_more buttom
  let number = $('.showcase_image_wall .show_more').data('only')
  $('.showcase_image_wall .show_more').click(function(){
    number += number 
    console.log(number);
    for ( let i =0;i<number;i++){
        $('.image_list .image_item').eq(i).show()
        $('.swiper-wrapper .product_item').eq(i).css('display','flex')
    }
    mySwiper.update(true)
    if($('.image_list .image_item').last().css('display') == 'block'){
        $('.showcase_image_wall .show_more').hide()
    }
  })
});